import { useEffect, useState } from 'react';
import { Marker, useMapEvents } from 'react-leaflet';
import { DivIcon, Point } from 'leaflet';
import MarkerIcon from '../../assets/img/controls/icons/marker.svg';
import { useSearchParams } from 'react-router-dom';

export const CustomPin = ({customPin,setCustomPin}:{customPin:boolean,setCustomPin:any}) => {
    const [position, setPosition] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const key=searchParams.get('key');
    
    
    useMapEvents({
        click(e: any) {
            if (customPin) {
                setPosition(e.latlng);
                setCustomPin('custom-pin');
                localStorage.setItem('custom_pin'+key, JSON.stringify(e.latlng));

            }
        }
    })

    useEffect(() => {
        const customPinData = localStorage.getItem('custom_pin'+key);
        if (customPinData){
            setPosition(JSON.parse(customPinData));
        }
    }, []);

    const icon = new DivIcon({
        iconSize:  new Point(21, 34),
        iconAnchor: new Point(10, 34),
        html: '<img src="' + MarkerIcon + '" width="20" height="35" />',
        className: 'custom-pin--marker',
    });

    return (position && <Marker position={position} icon={icon}></Marker>)
}
